// extracted by mini-css-extract-plugin
export default {"form":"Login_form__xawx9","gap":"Login_gap__W0Pw2"};